import {
  createAction,
  props,
} from '@ngrx/store';

const PREFIX = '[CORE]';

export const saveToken = createAction(
  `${PREFIX} SAVE_TOKEN`,
  props<{
    token: string;
  }>(),
);

export const setSomethingWentWrongModalAppComponent = createAction(
  `${PREFIX} SET_SOMETHING_WENT_WRONG_MODAL_APP_COMPONENT`,
  props<{
    isOpen: boolean;
  }>(),
);

export const setInstallAppWhatNextModal = createAction(
  `${PREFIX} SET_INSTALL_APP_WHAT_NEXT_MODAL`,
  props<{
    isOpen: boolean;
  }>(),
);

export const setAppNotDetectedModal = createAction(
  `${PREFIX} SET_APP_NOT_DETECTED_MODAL`,
  props<{
    isOpen: boolean;
  }>(),
);

export const setGoBackToLMSModal = createAction(
  `${PREFIX} SET_GO_BACK_TO_LMS_MODAL`,
  props<{
    isOpen: boolean;
  }>(),
);

export const setInvalidExamTokenModal = createAction(
  `${PREFIX} SET_INVALID_EXAM_TOKEN_MODAL`,
  props<{
    isOpen: boolean;
  }>(),
);

export const setUnsupportedOperatingSystemModal = createAction(
  `${PREFIX} SET_UNSUPPORTED_OPERATING_SYSTEM_MODAL`,
  props<{
    isOpen: boolean;
  }>(),
);

export const setChooseYourInstallerModal = createAction(
  `${PREFIX} SET_CHOOSE_YOUR_INSTALLER_MODAL`,
  props<{
    isOpen: boolean;
  }>(),
);
